package com.essntl.features.request.ui.addeditrequest

import com.essntl.features.client.domain.model.ClientModel
import com.essntl.features.request.domain.model.RequestModel
import com.essntl.features.travelagent.domain.model.TravelAgentModel
import com.mohamedrejeb.calf.core.PlatformContext

sealed interface AddEditRequestEvent {
    data class UpdateRequestFields(
        val request: RequestModel,
    ) : AddEditRequestEvent

    data object LoadMoreTravelAgent : AddEditRequestEvent

    data class SearchTravelAgent(val query: String) : AddEditRequestEvent

    data object AddRequest : AddEditRequestEvent

    data object EditRequest : AddEditRequestEvent

    data class GetRequest(
        val requestId: String,
    ) : AddEditRequestEvent

    data object ClearSuccessState : AddEditRequestEvent
    data object ClearAddEditTravelAgentSuccessState : AddEditRequestEvent

    data object ClearRequestState : AddEditRequestEvent

    data class AddClient(
        val client: ClientModel,
    ) : AddEditRequestEvent

    data class EditClient(
        val client: ClientModel,
    ) : AddEditRequestEvent

    data class RemoveClient(
        val clientId: String,
    ) : AddEditRequestEvent

    data class AddTravelAgent(
        val travelAgent: TravelAgentModel,
    ) : AddEditRequestEvent

    data class EditTravelAgent(
        val travelAgent: TravelAgentModel,
        val oldTravelAgent: TravelAgentModel,
        val context: PlatformContext,
    ) : AddEditRequestEvent
}